{
 "ground-zero": {
  "entries": [
   "East",
   "West"
  ],
  "spots": [
   {
    "entry": 0,
    "lat": 174.5,
    "lng": 117.5,
    "radius": 28,
    "count": 15,
    "label": true
   },
   {
    "entry": 0,
    "lat": 269.1,
    "lng": 132.1,
    "radius": 32.2,
    "count": 15
   },
   {
    "entry": 0,
    "lat": 156.2,
    "lng": 52.3,
    "radius": 18.5,
    "count": 10
   },
   {
    "entry": 0,
    "lat": 105.2,
    "lng": 64.9,
    "radius": 4.2,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 119.3,
    "lng": 180.8,
    "radius": 4.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 314.8,
    "lng": 101.8,
    "radius": 4.2,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 6,
    "lng": 74.2,
    "radius": 4.5,
    "count": 5,
    "label": true
   },
   {
    "entry": 1,
    "lat": -69.4,
    "lng": 142.8,
    "radius": 6.7,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -2.8,
    "lng": 121.5,
    "radius": 4.2,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -6.9,
    "lng": 179.9,
    "radius": 5.3,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -2.8,
    "lng": -8.4,
    "radius": 4.2,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -59.7,
    "lng": -0.7,
    "radius": 5,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -51.7,
    "lng": 73.6,
    "radius": 4.8,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 66.1,
    "lng": 137.2,
    "radius": 4.2,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -103.1,
    "lng": 44.7,
    "radius": 4.2,
    "count": 5
   }
  ]
 },
 "customs": {
  "entries": [
   "Boiler Tanks",
   "Customs"
  ],
  "spots": [
   {
    "entry": 0,
    "lat": -107.4,
    "lng": 595.4,
    "radius": 28.2,
    "count": 10,
    "label": true
   },
   {
    "entry": 0,
    "lat": -71.8,
    "lng": 491.7,
    "radius": 20.5,
    "count": 10
   },
   {
    "entry": 0,
    "lat": -105.8,
    "lng": 387.1,
    "radius": 24.4,
    "count": 10
   },
   {
    "entry": 0,
    "lat": -52.5,
    "lng": 570.1,
    "radius": 6.5,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 145.8,
    "lng": 584.1,
    "radius": 12.5,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -197.1,
    "lng": 291.7,
    "radius": 6.5,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 195.8,
    "lng": 522.4,
    "radius": 16.1,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 48,
    "lng": 545,
    "radius": 6.5,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 152.8,
    "lng": 360,
    "radius": 11.5,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -82.1,
    "lng": 315.8,
    "radius": 11,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 46.2,
    "lng": 645.3,
    "radius": 6.5,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -144.9,
    "lng": -218.7,
    "radius": 8.1,
    "count": 5,
    "label": true
   },
   {
    "entry": 1,
    "lat": -234.6,
    "lng": -194.3,
    "radius": 6.5,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 39.9,
    "lng": -132.9,
    "radius": 6.5,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -135.6,
    "lng": -151.8,
    "radius": 8.7,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -106.2,
    "lng": 96.6,
    "radius": 7.7,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -89.5,
    "lng": -309.9,
    "radius": 7.5,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -0.4,
    "lng": -214.6,
    "radius": 8.7,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -126.9,
    "lng": 16,
    "radius": 7.3,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 121.6,
    "lng": -14.7,
    "radius": 13.8,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -223.8,
    "lng": -321,
    "radius": 6.5,
    "count": 5
   }
  ]
 },
 "factory": {
  "entries": [
   "Factory"
  ],
  "spots": [
   {
    "entry": 0,
    "lat": 51.7,
    "lng": 7.1,
    "radius": 10.1,
    "count": 10,
    "label": true
   },
   {
    "entry": 0,
    "lat": 7,
    "lng": -45.4,
    "radius": 3,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -42.5,
    "lng": 10,
    "radius": 3,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -8.3,
    "lng": 41.1,
    "radius": 2.3,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 52.6,
    "lng": 58.2,
    "radius": 2.9,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 37.8,
    "lng": 15,
    "radius": 2.6,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 19.4,
    "lng": 30.3,
    "radius": 2.7,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -34,
    "lng": 32.7,
    "radius": 2.7,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -41.3,
    "lng": -17,
    "radius": 3.9,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 29.2,
    "lng": -22.2,
    "radius": 5.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -14.2,
    "lng": -1.1,
    "radius": 7.1,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 48.4,
    "lng": -44,
    "radius": 9.3,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -14.6,
    "lng": 20.2,
    "radius": 1.9,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 6.4,
    "lng": 58.2,
    "radius": 3.3,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 15.8,
    "lng": -5.6,
    "radius": 3.9,
    "count": 5
   }
  ]
 },
 "woods": {
  "entries": [
   "Old Railway Depot",
   "House"
  ],
  "spots": [
   {
    "entry": 0,
    "lat": 185.3,
    "lng": -524.6,
    "radius": 113.2,
    "count": 20,
    "label": true
   },
   {
    "entry": 0,
    "lat": -97.8,
    "lng": -500.7,
    "radius": 61.5,
    "count": 10
   },
   {
    "entry": 0,
    "lat": -173.1,
    "lng": -292.6,
    "radius": 55.5,
    "count": 10
   },
   {
    "entry": 0,
    "lat": 332.9,
    "lng": -276,
    "radius": 16.3,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -579.6,
    "lng": -61,
    "radius": 16.3,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -515.2,
    "lng": -418.8,
    "radius": 16.3,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -329,
    "lng": -615.8,
    "radius": 16.3,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 238,
    "lng": -359.3,
    "radius": 16.3,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 380.4,
    "lng": -92.3,
    "radius": 16.3,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 296.5,
    "lng": 477.1,
    "radius": 122.8,
    "count": 20,
    "label": true
   },
   {
    "entry": 1,
    "lat": -646.9,
    "lng": 368,
    "radius": 58.8,
    "count": 10
   },
   {
    "entry": 1,
    "lat": -29.2,
    "lng": 392.2,
    "radius": 57.6,
    "count": 10
   },
   {
    "entry": 1,
    "lat": -637.5,
    "lng": -260.3,
    "radius": 16.3,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -317.4,
    "lng": 231.4,
    "radius": 16.3,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 199.4,
    "lng": 228.4,
    "radius": 16.3,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 315.8,
    "lng": 279.9,
    "radius": 16.3,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -406.4,
    "lng": 389.7,
    "radius": 16.3,
    "count": 5
   },
   {
    "entry": null,
    "lat": -546.5,
    "lng": 84.6,
    "radius": 16.3,
    "count": 5
   }
  ]
 },
 "interchange": {
  "entries": [
   "Mall NW",
   "Mall SE"
  ],
  "spots": [
   {
    "entry": 0,
    "lat": -412.4,
    "lng": 121.8,
    "radius": 30.6,
    "count": 10,
    "label": true
   },
   {
    "entry": 0,
    "lat": -385.1,
    "lng": 25.4,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -192.5,
    "lng": 360.2,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -330.5,
    "lng": 216,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -435.3,
    "lng": 253.3,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 333.2,
    "lng": 315.7,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -395,
    "lng": 374.3,
    "radius": 11.8,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -10.8,
    "lng": 280.1,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -108.6,
    "lng": 339.4,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -287.8,
    "lng": 414.8,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -411,
    "lng": -182,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -392,
    "lng": -57.5,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 110.7,
    "lng": 291.4,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 262.8,
    "lng": -337.6,
    "radius": 10.4,
    "count": 5,
    "label": true
   },
   {
    "entry": 1,
    "lat": 273.3,
    "lng": -199,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 282.7,
    "lng": -90.9,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 277.5,
    "lng": 154,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 16.6,
    "lng": -239.5,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 107.3,
    "lng": -317.2,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 319.4,
    "lng": 26.2,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 377.5,
    "lng": 157.3,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -6.3,
    "lng": -330.4,
    "radius": 10.4,
    "count": 2
   },
   {
    "entry": null,
    "lat": -107.4,
    "lng": -317.7,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": null,
    "lat": -309.1,
    "lng": -276.7,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": null,
    "lat": -191.5,
    "lng": -289.6,
    "radius": 10.4,
    "count": 5
   },
   {
    "entry": null,
    "lat": -7.2,
    "lng": -331.7,
    "radius": 10.4,
    "count": 3
   }
  ]
 },
 "shoreline": {
  "entries": [
   "Village",
   "Riverside"
  ],
  "spots": [
   {
    "entry": 0,
    "lat": 190.9,
    "lng": 453.5,
    "radius": 12.4,
    "count": 5,
    "label": true
   },
   {
    "entry": 0,
    "lat": 333.2,
    "lng": 347.3,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 76,
    "lng": 426.4,
    "radius": 14.7,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -18,
    "lng": 443.6,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 143.5,
    "lng": 448.1,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 256.1,
    "lng": 392.1,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -268.4,
    "lng": 334.3,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 248.5,
    "lng": 225.2,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 200.6,
    "lng": -898.1,
    "radius": 12.4,
    "count": 5,
    "label": true
   },
   {
    "entry": 1,
    "lat": 97.3,
    "lng": -927,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 7.7,
    "lng": -875.3,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 372.7,
    "lng": -848,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 465.1,
    "lng": -785.8,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": 1,
    "lat": -10.3,
    "lng": -783.5,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 474.6,
    "lng": -647.5,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": null,
    "lat": -289.4,
    "lng": 173.8,
    "radius": 48.1,
    "count": 10
   },
   {
    "entry": null,
    "lat": 374.1,
    "lng": -332.8,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": null,
    "lat": 304.6,
    "lng": -38,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": null,
    "lat": 324.9,
    "lng": -184.7,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": null,
    "lat": -353.8,
    "lng": -271.9,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": null,
    "lat": -375.5,
    "lng": -405.1,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": null,
    "lat": 392.9,
    "lng": -454.3,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": null,
    "lat": 290.5,
    "lng": 92.4,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": null,
    "lat": -286,
    "lng": 3.4,
    "radius": 12.4,
    "count": 5
   },
   {
    "entry": null,
    "lat": 470.7,
    "lng": -532.8,
    "radius": 12.4,
    "count": 5
   }
  ]
 },
 "reserve": {
  "entries": [
   null
  ],
  "spots": [
   {
    "entry": 0,
    "lat": 69.6,
    "lng": -140.6,
    "radius": 32.6,
    "count": 10,
    "label": true
   },
   {
    "entry": 0,
    "lat": 38.1,
    "lng": 147.1,
    "radius": 6.5,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -23,
    "lng": -115.9,
    "radius": 6.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -172,
    "lng": 63.1,
    "radius": 6.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -33.8,
    "lng": 86.8,
    "radius": 9.5,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 64.8,
    "lng": 57.9,
    "radius": 6.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -234.9,
    "lng": 164.5,
    "radius": 8,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -101.5,
    "lng": 189.5,
    "radius": 6.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -167.7,
    "lng": 171.6,
    "radius": 11.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 193.8,
    "lng": -76,
    "radius": 6.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 6.6,
    "lng": 23.6,
    "radius": 6.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -167,
    "lng": -34.9,
    "radius": 12.7,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -130,
    "lng": -135.5,
    "radius": 6.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 15.7,
    "lng": -48.3,
    "radius": 6.4,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 182.9,
    "lng": -27.9,
    "radius": 6.4,
    "count": 4
   }
  ]
 },
 "lighthouse": {
  "entries": [
   "Tunnel",
   "North"
  ],
  "spots": [
   {
    "entry": 0,
    "lat": 104,
    "lng": 113.1,
    "radius": 12.7,
    "count": 5,
    "label": true
   },
   {
    "entry": 0,
    "lat": 373.2,
    "lng": 137.4,
    "radius": 12.7,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 482.1,
    "lng": -135.9,
    "radius": 12.7,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -68.5,
    "lng": -167.7,
    "radius": 12.7,
    "count": 5
   },
   {
    "entry": 0,
    "lat": 327.9,
    "lng": -61.5,
    "radius": 12.7,
    "count": 4
   },
   {
    "entry": 0,
    "lat": -113.9,
    "lng": 138.4,
    "radius": 12.7,
    "count": 4
   },
   {
    "entry": 0,
    "lat": 204.2,
    "lng": 86.2,
    "radius": 12.7,
    "count": 4
   },
   {
    "entry": 0,
    "lat": 214.4,
    "lng": -162.6,
    "radius": 12.7,
    "count": 4
   },
   {
    "entry": 1,
    "lat": -184.9,
    "lng": -212.9,
    "radius": 12.7,
    "count": 5,
    "label": true
   },
   {
    "entry": null,
    "lat": -929.3,
    "lng": 138.4,
    "radius": 12.7,
    "count": 5
   },
   {
    "entry": null,
    "lat": -263.3,
    "lng": -339.5,
    "radius": 12.7,
    "count": 5
   },
   {
    "entry": null,
    "lat": -919.7,
    "lng": 2.5,
    "radius": 12.7,
    "count": 5
   },
   {
    "entry": null,
    "lat": -895.7,
    "lng": -126.4,
    "radius": 12.7,
    "count": 5
   },
   {
    "entry": null,
    "lat": -760.2,
    "lng": 168.9,
    "radius": 12.7,
    "count": 5
   },
   {
    "entry": null,
    "lat": 0.5,
    "lng": -22.9,
    "radius": 12.7,
    "count": 5
   }
  ]
 },
 "streets-of-tarkov": {
  "entries": [
   null,
   null,
   null,
   null,
   null,
   null
  ],
  "spots": [
   {
    "entry": 0,
    "lat": 181.4,
    "lng": 200.6,
    "radius": 28.7,
    "count": 10,
    "label": true
   },
   {
    "entry": 0,
    "lat": 70,
    "lng": 265.1,
    "radius": 22.1,
    "count": 10
   },
   {
    "entry": 0,
    "lat": -162.5,
    "lng": 102.1,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -105.5,
    "lng": 233.4,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -135.4,
    "lng": -13.9,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -134.5,
    "lng": 53.2,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -130.7,
    "lng": 168.3,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -38.6,
    "lng": 244.7,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 410.5,
    "lng": 228.5,
    "radius": 7.2,
    "count": 6,
    "label": true
   },
   {
    "entry": 1,
    "lat": 415.8,
    "lng": 45.1,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 428.6,
    "lng": 155.8,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 336.7,
    "lng": -79,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 459.7,
    "lng": -65.7,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 1,
    "lat": 450,
    "lng": 95.7,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 2,
    "lat": 319.5,
    "lng": 210.5,
    "radius": 26.6,
    "count": 10,
    "label": true
   },
   {
    "entry": 2,
    "lat": 376.2,
    "lng": 272,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 2,
    "lat": 456.8,
    "lng": 185.6,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 2,
    "lat": 516.7,
    "lng": 274.1,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 2,
    "lat": 234.8,
    "lng": 177.3,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 3,
    "lat": 394.4,
    "lng": -185.9,
    "radius": 75.1,
    "count": 30,
    "label": true
   },
   {
    "entry": 4,
    "lat": -114.2,
    "lng": -50.8,
    "radius": 49.1,
    "count": 15,
    "label": true
   },
   {
    "entry": 4,
    "lat": -29.2,
    "lng": -150.6,
    "radius": 44.2,
    "count": 15
   },
   {
    "entry": 5,
    "lat": 181.6,
    "lng": -184.6,
    "radius": 23,
    "count": 10,
    "label": true
   },
   {
    "entry": 5,
    "lat": 260.4,
    "lng": -234.8,
    "radius": 24.4,
    "count": 10
   },
   {
    "entry": 5,
    "lat": 107.6,
    "lng": -176.3,
    "radius": 7.2,
    "count": 5
   }
  ]
 },
 "the-lab": {
  "entries": [
   null
  ],
  "spots": [
   {
    "entry": 0,
    "lat": -331,
    "lng": -120.3,
    "radius": 12.3,
    "count": 10,
    "label": true
   },
   {
    "entry": 0,
    "lat": -288.2,
    "lng": -253.2,
    "radius": 10.4,
    "count": 10
   },
   {
    "entry": 0,
    "lat": -256.9,
    "lng": -120.6,
    "radius": 15.7,
    "count": 9
   },
   {
    "entry": 0,
    "lat": -408.4,
    "lng": -115.6,
    "radius": 9.3,
    "count": 6
   },
   {
    "entry": 0,
    "lat": -321.7,
    "lng": -261,
    "radius": 5.1,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -355.3,
    "lng": -276.3,
    "radius": 7.2,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -340.1,
    "lng": -170.8,
    "radius": 4.5,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -385.2,
    "lng": -217.3,
    "radius": 3,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -291.9,
    "lng": -206.7,
    "radius": 3.5,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -417,
    "lng": -168.2,
    "radius": 3.3,
    "count": 5
   },
   {
    "entry": 0,
    "lat": -390.3,
    "lng": -269.3,
    "radius": 6.7,
    "count": 5
   }
  ]
 }
}
